import { KeyLabelPair } from "@/config/types";
import PspTextInput from "../pspTextInput/pspTextInput";
import { clsx } from "clsx/lite";
import { Checkbox } from "@fluentui/react-components";

export declare type SearchableOptionsProps<T extends string | number> = {
  options: KeyLabelPair<T>[];
  disabled?: boolean;
  placeholder?: string;
  searchQuery: string;
  onChangeSearchQuery: (query: string) => void;
  autoFocus?: boolean;
  label: string;
} & (
  | {
      value: T[];
      onChange: (value: T[]) => void;
      multiSelect: true;
    }
  | {
      value: T | null;
      onChange: (value: T | null) => void;
      multiSelect?: false;
    }
);

export function SearchableOptions<T extends string | number = string>({
  value,
  onChange,
  options,
  disabled,
  placeholder,
  label,
  searchQuery,
  onChangeSearchQuery,
  multiSelect,
  autoFocus,
}: SearchableOptionsProps<T>) {
  return (
    <div>
      <div className="pb-3">
        <PspTextInput
          placeholderString={placeholder}
          onChange={onChangeSearchQuery}
          value={searchQuery}
          labelString={label}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </div>
      <div className="flex flex-col h-80 overflow-y-auto">
        {options.map(({ key, label }) => (
          <button
            className={clsx(
              "py-3",
              "text-base",
              "cursor-pointer",
              "border-b",
              "border-neutral",
              disabled && "text-font-secondary",
              value === key && !multiSelect && "bg-primary-extra-light",
            )}
            key={`searchable-options-option-${key}`}
            onClick={() =>
              !disabled
                ? multiSelect
                  ? onChange(
                      value.includes(key)
                        ? value.filter((k) => k !== key)
                        : [...value, key],
                    )
                  : value === key
                    ? onChange(null)
                    : onChange(key)
                : {}
            }
          >
            <div className="flex flex-row gap-2">
              {multiSelect && (
                <div>
                  <Checkbox checked={value.includes(key)} />
                </div>
              )}
              <div className="px-3">{label}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
